import { render, staticRenderFns } from "./respect.vue?vue&type=template&id=c892eb2c&"
import script from "./respect.vue?vue&type=script&lang=ts&"
export * from "./respect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports